"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Arrays_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDuplicates = exports.remove = exports.range = exports.intersection = exports.getBatches = exports.formatStringList = exports.flatten = exports.filter = exports.difference = exports.deepClone = exports.cycle = exports.compact = exports.average = exports.Arrays = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
let Arrays = Arrays_1 = class Arrays {
    static average(numbers) {
        if (!numbers.length) {
            return undefined;
        }
        const total = numbers.reduce((sum, num) => sum + num, 0);
        return Math.floor(total / numbers.length);
    }
    static compact(array) {
        return array.filter(Boolean);
    }
    static *cycle(iterable) {
        const items = Array.from(iterable);
        if (items.length === 0)
            return;
        let index = 0;
        while (true) {
            yield items[index];
            index = (index + 1) % items.length;
        }
    }
    static deepClone(array) {
        return JSON.parse(JSON.stringify(array));
    }
    static difference(sourceArray, excludeArray) {
        const excludeSet = new Set(excludeArray);
        return sourceArray.filter((item) => !excludeSet.has(item));
    }
    static *filter(iterable, predicate) {
        for (const item of iterable) {
            if (predicate(item)) {
                yield item;
            }
        }
    }
    static flatten(array) {
        return array.reduce((flattenedArray, item) => Array.isArray(item)
            ? flattenedArray.concat(Arrays_1.flatten(item))
            : flattenedArray.concat(item), []);
    }
    static formatStringList(items) {
        if (items.length === 0) {
            return '';
        }
        else if (items.length === 1) {
            return items[0];
        }
        else if (items.length === 2) {
            return `${items[0]} and ${items[1]}`;
        }
        const allExceptLast = items.slice(0, -1).join(', ');
        return `${allExceptLast}, and ${items[items.length - 1]}`;
    }
    static *getBatches(items, size = 50) {
        for (let startIndex = 0; startIndex < items.length; startIndex += size) {
            yield {
                index: startIndex,
                items: items.slice(startIndex, startIndex + size),
            };
        }
    }
    static intersection(firstArray, secondArray) {
        const secondSet = new Set(secondArray);
        return firstArray.filter((item) => secondSet.has(item));
    }
    static *range(start, end, step = 1) {
        if (step === 0)
            throw new Error('Step cannot be zero.');
        if (step > 0) {
            for (let i = start; i < end; i += step) {
                yield i;
            }
        }
        else {
            for (let i = start; i > end; i += step) {
                yield i;
            }
        }
    }
    static remove(array, ...values) {
        const valuesToRemoveSet = new Set(values);
        return array.filter((item) => !valuesToRemoveSet.has(item));
    }
    static removeDuplicates(array) {
        return Array.from(new Set(array));
    }
};
exports.Arrays = Arrays;
exports.Arrays = Arrays = Arrays_1 = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log)
], Arrays);
exports.average = Arrays.average, exports.compact = Arrays.compact, exports.cycle = Arrays.cycle, exports.deepClone = Arrays.deepClone, exports.difference = Arrays.difference, exports.filter = Arrays.filter, exports.flatten = Arrays.flatten, exports.formatStringList = Arrays.formatStringList, exports.getBatches = Arrays.getBatches, exports.intersection = Arrays.intersection, exports.range = Arrays.range, exports.remove = Arrays.remove, exports.removeDuplicates = Arrays.removeDuplicates;
//# sourceMappingURL=arrays.js.map